// extracted by mini-css-extract-plugin
export default {"title":"AssignTaskPopup_title__mGvwC","action":"AssignTaskPopup_action__aobyI"};